export const IOS_USER_AGENT_REGEX = /iPad|iPhone|iPod/;
